var render = function render(){var _vm=this,_c=_vm._self._c;return _c('picture',{class:_vm.customClass,style:(_vm.customStyle)},[(_vm.webpUrl)?_c('source',{attrs:{"srcset":_vm.webpUrl,"type":"image/webp"}}):_vm._e(),_c('img',{attrs:{"src":_vm.pngUrl || _vm.defaultImage,"alt":_vm.altText},on:{"error":_vm.handleImageError}})])
}
var staticRenderFns = []

export { render, staticRenderFns }